/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccessLevelDto,
    AccessLevelDtoFromJSON,
    AccessLevelDtoFromJSONTyped,
    AccessLevelDtoToJSON,
    MachineTypeDto,
    MachineTypeDtoFromJSON,
    MachineTypeDtoFromJSONTyped,
    MachineTypeDtoToJSON,
    MachineUserSettingDto,
    MachineUserSettingDtoFromJSON,
    MachineUserSettingDtoToJSON,
    NextServiceDto,
    NextServiceDtoFromJSON,
    NextServiceDtoFromJSONTyped,
    NextServiceDtoToJSON,
    StateDto,
    StateDtoFromJSON,
    StateDtoFromJSONTyped,
    StateDtoToJSON,
    TagDto,
    TagDtoFromJSON,
    TagDtoFromJSONTyped,
    TagDtoToJSON,
    TelemetrySnapshotDto,
    TelemetrySnapshotDtoFromJSON,
    TelemetrySnapshotDtoFromJSONTyped,
    TelemetrySnapshotDtoToJSON,
} from './';
import { MaintenanceInfoDto, MaintenanceInfoDtoFromJSON, MaintenanceInfoDtoToJSON } from './MaintenanceInfoDto';

/**
 * 
 * @export
 * @interface MachineDto
 */
export interface MachineDto {
    /**
     * 
     * @type {number}
     * @memberof MachineDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MachineDto
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof MachineDto
     */
    notes: string;
    /**
     * 
     * @type {number}
     * @memberof MachineDto
     */
    organizationId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDto
     */
    machineTypeId: number;
    /**
     * 
     * @type {MachineTypeDto}
     * @memberof MachineDto
     */
    machineType: MachineTypeDto;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDto
     */
    isDeactivated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDto
     */
    isHybrid: boolean;
    /**
     * 
     * @type {string}
     * @memberof MachineDto
     */
    spsProgramVersion: string;
    /**
     * 
     * @type {string}
     * @memberof MachineDto
     */
    displayProgramVersion: string;
    /**
     * 
     * @type {string}
     * @memberof MachineDto
     */
    owner: string;
    /**
     * 
     * @type {string}
     * @memberof MachineDto
     */
    projectConstructionSite: string;
    /**
     * 
     * @type {StateDto}
     * @memberof MachineDto
     */
    state: StateDto;
    /**
     * 
     * @type {string}
     * @memberof MachineDto
     */
    stateText: string;
    /**
     * 
     * @type {Array<TagDto>}
     * @memberof MachineDto
     */
    tags?: Array<TagDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDto
     */
    hasWeightData: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDto
     */
    allowLocationList: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDto
     */
    useBlacklist: boolean;
    /**
     * 
     * @type {string}
     * @memberof MachineDto
     */
    errorBlackList: string;
    /**
     * 
     * @type {AccessLevelDto}
     * @memberof MachineDto
     */
    currentlyAuthenticatedUserAccessLevel: AccessLevelDto;
    /**
     * 
     * @type {TelemetrySnapshotDto}
     * @memberof MachineDto
     */
    telemetrySnapshot?: TelemetrySnapshotDto | null;
    /**
     * 
     * @type {NextServiceDto}
     * @memberof MachineDto
     */
    nextService?: NextServiceDto | null;
    /**
     * 
     * @type {MaintenanceInfoDto}
     * @memberof MachineDto
     */
    maintenanceInfo: MaintenanceInfoDto | null;
    /**
     * 
     * @type {MachineUserSettingDto}
     * @memberof MachineDto
     */
    machineUserSetting?: MachineUserSettingDto | null;
    /**
     * 
     * @type {string}
     * @memberof MachineDto
     */
    info: string;
    /**
     * 
     * @type {string}
     * @memberof MachineDto
     */
    logInfo: string;
}

export function MachineDtoFromJSON(json: any): MachineDto {
    return MachineDtoFromJSONTyped(json, false);
}

export function MachineDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'serialNumber': json['serialNumber'],
        'notes': json['notes'],
        'organizationId': !exists(json, 'organizationId') ? undefined : json['organizationId'],
        'machineTypeId': json['machineTypeId'],
        'machineType': MachineTypeDtoFromJSON(json['machineType']),
        'isDeactivated': !exists(json, 'isDeactivated') ? false : json['isDeactivated'],
        'isHybrid': !exists(json, 'isHybrid') ? false : json['isHybrid'],
        'spsProgramVersion': json['spsProgramVersion'],
        'displayProgramVersion': json['displayProgramVersion'],
        'owner': json['owner'],
        'projectConstructionSite': json['projectConstructionSite'],
        'state': StateDtoFromJSON(json['state']),
        'stateText': json['stateText'],
        'tags': !exists(json, 'tags') ? undefined : (json['tags'] === null ? null : (json['tags'] as Array<any>).map(TagDtoFromJSON)),
        'hasWeightData': json['hasWeightData'],
        'useBlacklist': json['useBlacklist'],
        'allowLocationList': json['allowLocationList'],
        'errorBlackList': json['errorBlackList'],
        'currentlyAuthenticatedUserAccessLevel': AccessLevelDtoFromJSON(json['currentlyAuthenticatedUserAccessLevel']),
        'telemetrySnapshot': !exists(json, 'telemetrySnapshot') ? undefined : TelemetrySnapshotDtoFromJSON(json['telemetrySnapshot']),
        'nextService': !exists(json, 'nextService') ? undefined : NextServiceDtoFromJSON(json['nextService']),
        'maintenanceInfo': !exists(json, 'maintenanceInfo') ? null : MaintenanceInfoDtoFromJSON(json['maintenanceInfo']),
        'machineUserSetting': !exists(json, 'machineUserSetting') ? undefined : MachineUserSettingDtoFromJSON(json['machineUserSetting']),
        'info': json['info'],
        'logInfo': json['logInfo'],
    };
}

export function MachineDtoToJSON(value?: MachineDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'serialNumber': value.serialNumber,
        'notes': value.notes,
        'organizationId': value.organizationId,
        'machineTypeId': value.machineTypeId,
        'machineType': MachineTypeDtoToJSON(value.machineType),
        'isDeactivated': value.isDeactivated,
        'isHybrid': value.isHybrid,
        'spsProgramVersion': value.spsProgramVersion,
        'displayProgramVersion': value.displayProgramVersion,
        'owner': value.owner,
        'projectConstructionSite': value.projectConstructionSite,
        'state': StateDtoToJSON(value.state),
        'stateText': value.stateText,
        'tags': value.tags === undefined ? undefined : (value.tags === null ? null : (value.tags as Array<any>).map(TagDtoToJSON)),
        'hasWeightData': value.hasWeightData,
        'useBlacklist': value.useBlacklist,
        'allowLocationList': value.allowLocationList,
        'errorBlackList': value.errorBlackList,
        'currentlyAuthenticatedUserAccessLevel': AccessLevelDtoToJSON(value.currentlyAuthenticatedUserAccessLevel),
        'telemetrySnapshot': TelemetrySnapshotDtoToJSON(value.telemetrySnapshot),
        'nextService': NextServiceDtoToJSON(value.nextService),
        'maintenanceInfo': MaintenanceInfoDtoToJSON(value.maintenanceInfo),
        'machineUserSetting': MachineUserSettingDtoToJSON(value.machineUserSetting),
        'info': value.info,
        'logInfo': value.logInfo,
    };
}


